import { Box, Grid, InputAdornment, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import getSymbolFromCurrency from 'currency-symbol-map';
import { fr } from 'date-fns/locale/fr';

export const RefundFormInputs = ({
  ticket,
  formState,
  errorFormState,
  onInputChange,
}) => {
  const minDate = new Date().setFullYear(2017);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
      }}
    >
      {/* Ligne Nom et Prénom */}
      <Grid container spacing={2}>
        <Grid size={6}>
          <TextField
            label="Nom"
            value={formState.lastName}
            onChange={(e) => onInputChange('lastName', e.target.value)}
            fullWidth
            error={Boolean(errorFormState.lastName)} // Vérifier s'il y a une erreur pour ce champ
            helperText={errorFormState.lastName} // Afficher le message d'erreur si présent
          />
        </Grid>
        <Grid size={6}>
          <TextField
            label="Prénom"
            value={formState.firstName}
            onChange={(e) => onInputChange('firstName', e.target.value)}
            fullWidth
            error={Boolean(errorFormState.firstName)} // Vérifier s'il y a une erreur pour ce champ
            helperText={errorFormState.firstName} // Afficher le message d'erreur si présent
          />
        </Grid>
      </Grid>
      {/* Ligne Email */}
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            label="Email"
            value={formState.email}
            onChange={(e) => onInputChange('email', e.target.value)}
            fullWidth
            error={Boolean(errorFormState.email)} // Vérifier s'il y a une erreur pour ce champ
            helperText={errorFormState.email} // Afficher le message d'erreur si présent
          />
        </Grid>
      </Grid>
      {/* Ligne Référence commande et Date de la commande */}
      <Grid container spacing={2}>
        <Grid size={4}>
          <TextField
            label="Référence commande"
            value={formState.orderRef}
            disabled
            fullWidth
            error={Boolean(errorFormState.orderRef)} // Vérifier s'il y a une erreur pour ce champ
            helperText={errorFormState.orderRef} // Afficher le message d'erreur si présent
          />
        </Grid>
        <Grid size={2}>
          <TextField
            label="Montant"
            value={formState.total}
            disabled
            fullWidth
            // Vérifier s'il y a une erreur pour ce champ
            error={Boolean(errorFormState.total)}
            helperText={errorFormState.total} // Afficher le message d'erreur si présent
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    {getSymbolFromCurrency(
                      ticket?.contact?.store?.country?.currency?.code
                    )}
                  </InputAdornment>
                ),
              },
            }}
          />
        </Grid>
        <Grid size={3}>
          <TextField
            label="Méthode paiement"
            value={formState.paymentMethod}
            onChange={(date) => onInputChange('paymentMethod', date)}
            disabled={formState.isPaymentMethodFieldProvided}
            fullWidth
            error={Boolean(errorFormState.paymentMethod)} // Vérifier s'il y a une erreur pour ce champ
            helperText={errorFormState.paymentMethod} // Afficher le message d'erreur si présent
          />
        </Grid>
        <Grid size={3}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
            <DatePicker
              disabled={formState.isOrderedAtFieldProvided}
              label="Date commande"
              onChange={(newValue) => onInputChange('orderedAt', newValue)}
              value={formState.orderedAt}
              defaultValue={formState.orderedAt}
              minDate={minDate}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
    </Box>
  );
};
